import { environment as ENV } from './../../../environments/environment';
import { LocalStorageService } from './../../shared/services/loca-storage.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NoAuthPaymentGuardService implements CanActivate {

  constructor(
    private _storageService: LocalStorageService,
    private _router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const authPayment: any = await this._storageService.get(ENV.environment.KEYS.PAYMENT_AUTH);

    if (authPayment) {
      console.log('Toco redireccionar :>> ');
      this._router.navigate(['/payment/invoice-payment']);
    }
    return !authPayment;
  }



}



// WEBPACK FOOTER //
// ./src/app/core/guards/no-auth-payment-guard.service.ts